//
// Signin.js
// - ------------------------------------------------------
// - Functions to support the Signin page
// - ------------------------------------------------------
//
const Airtable = require('airtable');
const base = new Airtable({apiKey: 'keyCv10aSA2Vxn4Ch'}).base('appKMHuPgfJLToeN1');

$(document).ready(function(){
  $('#signin_error').hide();
  $('#sign_in').click(function(){
    $('#signin_error').hide();
    const loginName = $("#loginName").val();
    console.log("loginName",loginName.length);
    if (loginName.length){
      console.log("pass");
      base('users').select({
          view: 'Grid view'
      }).firstPage(function(err, records) {
        let flag = false;
        if (err) {
          console.error(err);
          $('#signin_error').show();
          return; }
        records.forEach(function(record) {
          if (record.fields["Name"].toLowerCase() === loginName.toLowerCase()){
            flag = true;
            localStorage.setItem('uuid', record.fields.uuid);
          }
        });
        if (flag === true){
          $('#signin_error').hide();
          window.location.replace('moodandfood.html');
        } else {
          $('#signin_error').show();
        }
      });
      
    } else {
      $('#signin_error').show();
    }

  });
});
